import type { TTranslationOptions } from '~/composables/useLang'
import { ContentType } from '~/store/storeConfig'
import type { CategoryItem } from '~/types/searchTypes'

export default (t?: (value: string, opts?: TTranslationOptions) => string, contentType?: ContentType): CategoryItem => {
  const title = contentType === ContentType.Offers ? t?.('offers.all_offers') : t?.('category.all-categories')

  return {
    id: 0,
    name: title,
    title,
    slug: null,
    position: 0,
    children: [],
    pageTitle: title,
  } as unknown as CategoryItem
}
